import styled from 'styled-components';

export const BreakdownButtonContainer = styled.div`
    display: inline;

    Button {
        padding-left: 8px;
    }

    .base-deal-breakdown-icon {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;
